export const MARKET_PERIODS = ['1h', '24h', '7d', '30d'];
export const SIGNAL_LABEL = {
    breakout_high: '24h breakout',
    breakout_low: '24h breakdown',
    near_high: 'Near 30d high',
    near_low: 'Near 30d low',
    overbought: 'Overbought',
    oversold: 'Oversold',
    momentum: 'Momentum',
    ma_cross_up: 'MA cross up',
    ma_cross_down: 'MA cross down',
    vol_spike: 'Volatility spike',
    high_52w: 'New 52-week high',
    low_52w: 'New 52-week low',
    golden_cross: '50/200-day cross up',
    death_cross: '50/200-day cross down',
    earnings_soon: 'Earnings soon',
    event_soon: 'Event in 24h',
};
export const TREND_LABEL = { up: 'Uptrend', down: 'Downtrend', sideways: 'Sideways' };
export const DAILY_TREND_LABEL = { strong_up: 'Strong up', up: 'Up', sideways: 'Sideways', down: 'Down', strong_down: 'Strong down' };
export const WATCHLIST_MAX = 20;
export const WATCHLIST_SYMBOLS_MAX = 200;
export const MARKET_COLUMNS = [
    { id: 'price', label: 'Price' },
    { id: 'change', label: 'Change' },
    { id: 'range', label: 'Range' },
    { id: 'trend', label: 'Trend' },
    /** Our clients' long share once enough hold it, otherwise the wider market's (retail, futures speculators, analysts). */
    { id: 'sentiment', label: 'Sentiment' },
    /** A screen that fired, otherwise the daily trend (the hourly one with too little daily history). */
    { id: 'signal', label: 'Signal' },
    /** Volume across the market: crypto 24h across exchanges, stocks and ETFs average daily, futures open interest, activity. */
    { id: 'volume', label: 'Volume' },
    /** 24h volume traded on this platform (live accounts). */
    { id: 'mvol', label: 'Volume, this platform' },
    { id: 'mcap', label: 'Market cap' },
    { id: 'range52w', label: '52-week range' },
    { id: 'ytd', label: 'Year to date' },
    { id: 'traders', label: 'Traders' },
    { id: 'oi', label: 'Open interest' },
    { id: 'leverage', label: 'Max leverage' },
    { id: 'swap', label: 'Swap long / short' },
    { id: 'correlation', label: 'Vs my portfolio' },
    { id: 'status', label: 'Status' },
];
export const DEFAULT_MARKET_COLUMNS = ['price', 'change', 'trend', 'sentiment', 'signal', 'volume', 'status'];
/** Columns a tab opens with until the client picks their own: the ones that tab has data for. */
export const TAB_DEFAULT_COLUMNS = {
    CRYPTO: ['price', 'change', 'trend', 'sentiment', 'signal', 'volume', 'mcap'],
    STOCK: ['price', 'change', 'trend', 'sentiment', 'signal', 'volume', 'mcap', 'status'],
    COMMODITY: ['price', 'change', 'trend', 'sentiment', 'signal', 'volume', 'range52w', 'status'],
    INDEX: ['price', 'change', 'trend', 'sentiment', 'signal', 'volume', 'ytd', 'status'],
    FX: ['price', 'change', 'trend', 'sentiment', 'signal', 'volume', 'swap', 'status'],
};
export const SAVED_VIEWS_MAX = 20;
export const ASSET_ALERT_KINDS = ['price_above', 'price_below', 'move', 'range_break', 'market_open', 'event'];
export const PORTFOLIO_ALERT_KINDS = ['position_pnl', 'tp_sl_near', 'equity_drawdown', 'margin_level', 'concentration', 'daily_summary'];
export const ALERT_KINDS = [...ASSET_ALERT_KINDS, 'watchlist_move', ...PORTFOLIO_ALERT_KINDS, 'key_events'];
export const ALERT_KIND_LABEL = {
    price_above: 'Price rises above',
    price_below: 'Price falls below',
    move: 'Moves by %',
    range_break: 'Breaks high / low',
    market_open: 'Market opens',
    event: 'Economic event',
    watchlist_move: 'Watchlist move',
    position_pnl: 'Position P&L',
    tp_sl_near: 'Near TP / SL',
    equity_drawdown: 'Equity drawdown',
    margin_level: 'Margin level',
    concentration: 'Concentration',
    daily_summary: 'Daily summary',
    key_events: 'Key economic events',
};
export const ALERT_CHANNELS = ['bell', 'email', 'push'];
export const ALERTS_MAX_ACTIVE = 50;
export const ALERT_MIN_COOLDOWN_SEC = 60;
/** Minutes-before choices for economic event reminders. */
export const EVENT_REMIND_MINUTES = [5, 15, 30, 60];
export const MARKETS_DISCLAIMER = 'Market data, signals, sentiment and summaries are information only, not investment advice. CFDs are leveraged products and you can lose money rapidly.';
//# sourceMappingURL=markets.js.map